import { createAction, props } from '@ngrx/store';
import { User } from '../domain/models/user/user';
import { DashboardStats } from '../domain/models/dashboard-stats';
import { FileWithUserInfo } from '../domain/models/file/file-user-info';
import { CompanyWithFiles } from '../domain/models/company/company-with-files';
import { UserStats } from '../domain/models/user/user-stats';
import { UserProfile } from '../domain/enums/user-profile';
import { CompanyStats } from '../domain/models/company/company-stats';
import { CurrentBilling } from '../domain/models/billing/current-billing';

export const loadStatsForPeriod = createAction(
  '[Stats] Load Stats For Period',
  props<{
    startDate: Date;
    endDate: Date;
  }>(),
);

export const loadStatsForPeriodAdmin = createAction(
  '[Stats] Load Stats For Period',
  props<{
    startDate: Date;
    endDate: Date;
  }>(),
);

export const loadStatsForPeriodSuccess = createAction(
  '[Stats] Load Stats For Period Success',
  props<{ dashboardStats: DashboardStats }>(),
);

export const loadStatsForPeriodAdminSuccess = createAction(
  '[Stats] Load Stats For Period Admin Success',
  props<{ dashboardStats: DashboardStats }>(),
);

export const loadStatsForPeriodFailure = createAction(
  '[Stats] Load Stats For Period Failure',
  props<{ error: string }>(),
);

export const loadStatsForPeriodAdminFailure = createAction(
  '[Stats] Load Stats For Period Admin Failure',
  props<{ error: string }>(),
);

export const loadConvertedFiles = createAction(
  '[Admin] Load Converted Files',
  props<{
    page: number;
    pageSize?: number;
    search?: string;
    fileType?: string;
    sortColumn?: string;
    sortDirection?: 'asc' | 'desc';
    startDate?: Date;
    endDate?: Date;
    companyIds?: string[];
  }>(),
);

export const loadConvertedFilesSuccess = createAction(
  '[Admin] Load Converted Files Success',
  props<{
    items: FileWithUserInfo[];
    total: number;
    page: number;
    pageSize: number;
    search?: string;
    fileType?: string;
    sortColumn?: string;
    sortDirection?: 'asc' | 'desc';
    startDate?: Date;
    endDate?: Date;
    companyIds?: string[];
  }>(),
);

export const loadConvertedFilesFailure = createAction(
  '[Admin] Load Converted Files Failure',
  props<{ error: string }>(),
);
export const loadUsers = createAction(
  '[Admin] Load Users',
  props<{
    page: number;
    pageSize?: number;
    search?: string;
    sortColumn?: string;
    sortDirection?: 'asc' | 'desc';
    profiles?: UserProfile[];
    status?: string[];
  }>(),
);
export const loadUsersSuccess = createAction(
  '[Admin] Load Users Success',
  props<{
    items: User[];
    total: number;
    page: number;
    pageSize: number;
    search?: string;
    sortColumn?: string;
    sortDirection?: 'asc' | 'desc';
  }>(),
);
export const loadUserById = createAction(
  '[Admin] Load User By Id',
  props<{ id: string }>(),
);

export const loadUserByIdSuccess = createAction(
  '[Admin] Load User By Id Success',
  props<{ user: User }>(),
);

export const loadUserByIdFailure = createAction(
  '[Admin] Load User By Id Failure',
  props<{ error: string }>(),
);

export const loadUserStatsByPeriod = createAction(
  '[Admin] Load User Stats By Period',
  props<{ oidcId: string; startDate: Date; endDate: Date }>(),
);

export const loadUserStatsByPeriodSuccess = createAction(
  '[Admin] Load User Stats By Period Success',
  props<{ userStats: UserStats }>(),
);

export const loadUserStatsByPeriodFailure = createAction(
  '[Admin] Load User Stats By Period Failure',
  props<{ error: string }>(),
);

export const loadCompanies = createAction(
  '[Admin] Load Companies',
  props<{
    page: number;
    pageSize?: number;
    search?: string;
    sortColumn?: string;
    sortDirection?: 'asc' | 'desc';
  }>(),
);
export const loadCompaniesSuccess = createAction(
  '[Admin] Load Companies Success',
  props<{
    items: CompanyWithFiles[];
    total: number;
    page: number;
    pageSize: number;
    search?: string;
    sortColumn?: string;
    sortDirection?: 'asc' | 'desc';
  }>(),
);
export const loadCompanyById = createAction(
  '[Admin] Load Company By Id',
  props<{ id: string }>(),
);

export const loadCompanyByIdSuccess = createAction(
  '[Admin] Load Company By Id Success',
  props<{ company: CompanyWithFiles }>(),
);

export const loadCompanyByIdFailure = createAction(
  '[Admin] Load Company By Id Failure',
  props<{ error: string }>(),
);

export const loadCompanyStats = createAction(
  '[Admin] Load Company Stats',
  props<{ id: string; startDate?: Date; endDate?: Date }>(),
);

export const loadCompanyStatsSuccess = createAction(
  '[Admin] Load Company Stats Success',
  props<{ companyStats: CompanyStats }>(),
);

export const loadCompanyStatsFailure = createAction(
  '[Admin] Load Company Stats Failure',
  props<{ error: string }>(),
);

export const loadCurrentBilling = createAction('[Admin] Load Current Billing');

export const loadCurrentBillingSuccess = createAction(
  '[Admin] Load Current Billing Success',
  props<{ billing: CurrentBilling }>(),
);

export const loadCurrentBillingFailure = createAction(
  '[Admin] Load Current Billing Failure',
  props<{ error: string }>(),
);

export const loadSelectedCompanyBilling = createAction(
  '[Admin] Load Selected Company Billing',
  props<{ id: string }>(),
);

export const loadSelectedCompanyBillingSuccess = createAction(
  '[Admin] Load Selected Company Billing Success',
  props<{ selectedCompanyBilling: CurrentBilling }>(),
);

export const loadSelectedCompanyBillingFailure = createAction(
  '[Admin] Load Selected Company Billing Failure',
  props<{ error: string }>(),
);

export const downloadCompanyStatsCsv = createAction(
  '[Dashboard] Download Company Stats CSV',
  props<{
    startDate: Date;
    endDate: Date;
  }>(),
);

export const downloadCompanyStatsCsvSuccess = createAction(
  '[Dashboard] Download Company Stats CSV Success',
);

export const downloadCompanyStatsCsvFailure = createAction(
  '[Dashboard] Download Company Stats CSV Failure',
  props<{ error: string }>(),
);

export const downloadCompaniesStatsCsv = createAction(
  '[Dashboard] Download Companies Stats CSV',
  props<{
    startDate: Date;
    endDate: Date;
  }>(),
);

export const downloadCompaniesStatsCsvSuccess = createAction(
  '[Dashboard] Download Companies Stats CSV Success',
);

export const downloadCompaniesStatsCsvFailure = createAction(
  '[Dashboard] Download Companies Stats CSV Failure',
  props<{ error: string }>(),
);

export const downloadCompanyStatsCsvById = createAction(
  '[Admin] Download Company Stats CSV By Id',
  props<{
    companyId: string;
    companyName: string;
    startDate: Date;
    endDate: Date;
  }>(),
);

export const downloadCompanyStatsCsvByIdSuccess = createAction(
  '[Admin] Download Company Stats CSV By Id Success',
  props<{ companyId: string }>(),
);

export const downloadCompanyStatsCsvByIdFailure = createAction(
  '[Admin] Download Company Stats CSV By Id Failure',
  props<{ companyId: string; error: string }>(),
);

export const downloadMonthlyBillingCsv = createAction(
  '[Dashboard] Download Monthly Billing CSV',
);

export const downloadMonthlyBillingCsvSuccess = createAction(
  '[Dashboard] Download Monthly Billing CSV Success',
);

export const downloadMonthlyBillingCsvFailure = createAction(
  '[Dashboard] Download Monthly Billing CSV Failure',
  props<{ error: string }>(),
);

export const downloadCompanyMonthlyBillingCsvById = createAction(
  '[Admin]  Download Company Monthly Billing CSV By Id',
  props<{ companyId: string; companyName: string }>(),
);

export const downloadCompanyMonthlyBillingCsvByIdSuccess = createAction(
  '[Admin]  Download Company Monthly Billing CSV By Id Success',
  props<{ companyId: string }>(),
);

export const downloadCompanyMonthlyBillingCsvByIdFailure = createAction(
  '[Admin] Download Company Monthly Billing CSV By Id Failure',
  props<{ companyId: string; error: string }>(),
);
